import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import colorSharp from "../assets/img/color-sharp.png";
import "react-multi-carousel/lib/styles.css";
import javascript from "../assets/img/javascript.png";
import firebase from "../assets/img/firebase.png";
import html from "../assets/img/html.png";
import react from "../assets/img/react.png";
import css from "../assets/img/css.png";
import typescript from "../assets/img/typescript.png";
import bootstrap from "../assets/img/bootstrap.png";
import nextjs from "../assets/img/nextjs.png";
import graphql from "../assets/img/graphql-icon.png";
import mongodb from "../assets/img/mongodb-icon.png";
import nodejs from "../assets/img/node-js-icon.png";
import ruby from "../assets/img/ruby-on-rails-icon.png";
import tailwind from "../assets/img/tailwind-css-icon.png";
import azure from "../assets/img/azure-icon.png";
import git from "../assets/img/git-icon.png";
import redux from "../assets/img/redux-icon.png";


// Carousel responsive configuration
const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

// Skills data array
const skillsData = [
  { icon: typescript, name: "TypeScript" },
  { icon: javascript, name: "JavaScript" },
  { icon: react, name: "React JS / React Native" },
  { icon: nextjs, name: "Next JS" },
  { icon: graphql, name: "GraphQL" },
  { icon: mongodb, name: "MongoDB" },
  { icon: azure, name: "Azure" },
  { icon: nodejs, name: "Node.js" },
  { icon: ruby, name: "Ruby on Rails" },
  { icon: git, name: "Git" },
  { icon: redux, name: "Redux" },
  { icon: firebase, name: "Firebase" },
  { icon: css, name: "CSS" },
  { icon: html, name: "HTML" },
  { icon: bootstrap, name: "Bootstrap" },
  { icon: tailwind, name: "Tailwind CSS" },
];

// Skill Item Component
const SkillItem = ({ icon, name }) => (
  <div className="item">
    <img src={icon} alt={name} />
    <h5>{name}</h5>
  </div>
);

export const Skills = () => {
  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>Skills</h2>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="owl-carousel owl-theme skill-slider"
              >
                {skillsData.map((skill, index) => (
                  <SkillItem key={index} {...skill} />
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  );
};